var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"body-2 red-underline-animation px-2"},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v("←"),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }